/**
 * Create Plan Tool - Schema Definitions
 * 
 * Zod schemas for creating presentation plans with sections and slides.
 */

import { z } from "zod";
import { SectionSchema, type Plan } from "../types";

// ═══════════════════════════════════════════════════════════════════════════
// INPUT SCHEMAS
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Parameters for creating a new plan
 */
export const CreatePlanParamsSchema = z.object({
    targetSlideCount: z.number()
        .int()
        .positive()
        .optional()
        .describe('Target number of slides for the presentation (can be approximate)'),
    sections: z.array(SectionSchema)
        .min(1, 'Plan must have at least one section')
        .describe('Array of sections in the presentation. Each section groups related slides.')
});

// ═══════════════════════════════════════════════════════════════════════════
// OUTPUT TYPES
// ═══════════════════════════════════════════════════════════════════════════

/**
 * Response from creating a plan
 */
export interface CreatePlanResponse {
    success: boolean;
    plan: Plan;
    message: string;
    metadata?: {
        targetSlideCount?: number;
        actualSlideCount: number;
        variance?: number;
    };
}

// ═══════════════════════════════════════════════════════════════════════════
// TYPE EXPORTS
// ═══════════════════════════════════════════════════════════════════════════

export type CreatePlanParams = z.infer<typeof CreatePlanParamsSchema>;

